<template>
  <form-item-wrapper
    :designer="designer"
    :field="field"
    :rules="rules"
    :design-state="designState"
    :parent-widget="parentWidget"
    :parent-list="parentList"
    :index-of-parent-list="indexOfParentList"
    :sub-form-row-index="subFormRowIndex"
    :sub-form-col-index="subFormColIndex"
    :sub-form-row-id="subFormRowId"
  >
    <div>
      <div class="readonly-mode-field field" :class="isRuntime ? '' : 'designStyle'">
        <div class="fieldContent">
          <i :class="field.options.prefixIcon"></i>
          <span>{{ field.options.prefixText }}</span>
          <div :style="{ 'text-align': field.options.contentAlign || 'left' }">
            {{ isRuntime ? formatResultStr(finallyReuslt) : "" }}
          </div>
          <span>{{ field.options.suffixText }}</span>
          <i :class="field.options.suffixIcon"></i>
        </div>
      </div>
      <div v-if="field.options.displayUppercase && isRuntime" class="ChineseUppercase">
        {{ chineseUppercaseFinallyReuslt }}
      </div>
    </div>

    <!-- <el-input>
      <div>sss</div>
    </el-input> -->
    <!-- <template v-if="isReadMode"> </template> -->
  </form-item-wrapper>
</template>

<script>
import { VFormSDK } from "@/CommonDP/lib/vform/VFormDesigner.umd.min.js";
import { cloneDeep } from "lodash";
const { fieldMixin, i18n, FormItemWrapper, emitter } = VFormSDK;

export default {
  // eslint-disable-next-line vue/name-property-casing
  name: "calc-widget",
  componentName: "FieldWidget",
  components: {
    FormItemWrapper
  },
  mixins: [emitter, fieldMixin, i18n],
  props: {
    field: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number,
    designer: Object,

    designState: {
      type: Boolean,
      default: false
    },

    subFormRowIndex: {
      /* 子表单组件行索引，从0开始计数 */ type: Number,
      default: -1
    },
    subFormColIndex: {
      /* 子表单组件列索引，从0开始计数 */ type: Number,
      default: -1
    },
    subFormRowId: {
      /* 子表单组件行Id，唯一id且不可变 */ type: String,
      default: ""
    }
  },

  inject: ["refList", "globalOptionData", "globalModel"],
  data() {
    return {
      oldFieldValue: null, // field组件change之前的值
      fieldModel: null,
      rules: [],
      isModelDataInit: false,
      chineseUppercaseFinallyReuslt: ""
    };
  },
  computed: {
    inputType() {
      if (this.field.options.type === "number") {
        return "text"; // 当input的type设置为number时，如果输入非数字字符，则v-model拿到的值为空字符串，无法实现输入校验！故屏蔽之！！
      }

      return this.field.options.type;
    },
    isRuntime() {
      return !this.designState && !this.getFormRef()?.previewState;
    },
    finallyReuslt() {
      if (this.isModelDataInit) {
        const result = this.dynamicCalc();
        if (this.subFormRowId) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.globalModel.formModel[this.parentWidget.options.name][this.subFormRowIndex][this.field.options.name] = result;
        } else {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.globalModel.formModel[this.field.options.name] = result;
        }
        return result;
      } else {
        return "";
      }
    }
  },
  beforeCreate() {},

  created() {
    /* 注意：子组件mounted在父组件created之后、父组件mounted之前触发，故子组件mounted需要用到的prop
         需要在父组件created中初始化！！ */
    this.registerToRefList();
    this.initFieldModel();
    this.initEventHandler();
    this.buildFieldRules();

    this.handleOnCreated();
  },

  mounted() {
    this.handleOnMounted();
    let count = 0;
    console.log(this.isRuntime, " this.isRuntime()");
    if (!Object.keys(this.globalModel?.formModel || {}).length && this.isRuntime) {
      this.timer = setInterval(() => {
        if (Object.keys(this.globalModel.formModel || {}).length) {
          this.isModelDataInit = true;
          clearInterval(this.timer);
          console.log("success");
        }
        console.log("count");
        count++;
        // 如果大于25次则取消
        if (count > 25) clearInterval(this.timer);
      }, 500);
    } else {
      this.isModelDataInit = true;
    }
  },

  beforeDestroy() {
    this.unregisterFromRefList();
    this.timer && clearInterval(this.timer);
  },

  methods: {
    numberToChineseMoney(amount) {
      // 汉字的数字
      const cnNums = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
      // 基本单位
      const cnIntRadice = ["", "拾", "佰", "仟"];
      // 对应整数部分扩展单位
      const cnIntUnits = ["", "万", "亿", "兆"];
      // 对应小数部分单位
      const cnDecUnits = ["角", "分", "毫", "厘"];
      // 整数金额时后面跟的字符
      const cnInteger = "整";
      // 整型完以后的单位
      const cnIntLast = "元";
      // 最大处理的数字
      const maxNum = 9999999999999999.99;
      // 金额整数部分
      let integerNum;
      // 金额小数部分
      let decimalNum;
      // 输出的中文金额字符串
      let chineseStr = "";
      // 分离金额后用的数组，预定义
      let parts;
      if (amount === "") {
        return "";
      }
      amount = parseFloat(amount);
      if (amount >= maxNum) {
        // 超出最大处理数字
        return "";
      }
      if (amount === 0) {
        chineseStr = cnNums[0] + cnIntLast + cnInteger;
        return chineseStr;
      }
      // 转换为字符串
      amount = amount.toString();
      if (amount.indexOf(".") === -1) {
        integerNum = amount;
        decimalNum = "";
      } else {
        parts = amount.split(".");
        integerNum = parts[0];
        decimalNum = parts[1].substr(0, 4);
      }
      // 获取整型部分转换
      if (parseInt(integerNum, 10) > 0) {
        let zeroCount = 0;
        const IntLen = integerNum.length;
        for (let i = 0; i < IntLen; i++) {
          const n = integerNum.substr(i, 1);
          const p = IntLen - i - 1;
          const q = p / 4;
          const m = p % 4;
          if (n === "0") {
            zeroCount++;
          } else {
            if (zeroCount > 0) {
              chineseStr += cnNums[0];
            }
            // 归零
            zeroCount = 0;
            chineseStr += cnNums[parseInt(n, 10)] + cnIntRadice[m];
          }
          if (m === 0 && zeroCount < 4) {
            chineseStr += cnIntUnits[q];
          }
        }
        chineseStr += cnIntLast;
      }
      // 小数部分
      if (decimalNum !== "") {
        const decLen = decimalNum.length;
        for (let i = 0; i < decLen; i++) {
          const n = decimalNum.substr(i, 1);
          if (n !== "0") {
            chineseStr += cnNums[Number(n)] + cnDecUnits[i];
          }
        }
      }
      if (chineseStr === "") {
        chineseStr += cnNums[0] + cnIntLast + cnInteger;
      } else if (decimalNum === "") {
        chineseStr += cnInteger;
      }
      return chineseStr;
    },

    displayThousands(number) {
      if (typeof number === "number") {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else if (typeof number === "string") {
        return number.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        console.warn("传入的数据类型不正确");
        return number;
      }
    },
    formatResultStr(numb) {
      try {
        numb = parseFloat(numb);
      } catch (error) {
        console.error(error);
        return;
      }
      const {
        options: { jyhtPrecision, thousandSeparator, displayPercent }
      } = this.field;
      this.chineseUppercaseFinallyReuslt = this.numberToChineseMoney(numb);
      if (displayPercent) {
        numb = numb * 100;
      }
      console.log(typeof numb);
      if (jyhtPrecision) {
        numb = numb.toFixed(jyhtPrecision);
      }
      if (thousandSeparator) {
        numb = this.displayThousands(numb);
      }
      if (displayPercent) {
        numb += "%";
      }
      return numb;
    },
    dynamicCalc() {
      const rule = this.field.options.computationalFormula;
      const resultString = rule.reduce((prev, next, index) => {
        if (next.type === "field") {
          console.log(next.key, "next.key");
          if (next.isMianTable) {
            return prev + this.disposeValue(this.globalModel.formModel[next.key], rule[index - 1]?.value);
          } else {
            // 如果是在子表单内
            if (this.subFormRowId) {
              let targetObj = this.globalModel.formModel[this.parentWidget.options.name][this.subFormRowIndex];
              targetObj = cloneDeep(targetObj);
              this.unprefix(targetObj);
              return prev + this.disposeValue(targetObj[next.key], rule[index - 1]?.value);
            } else {
              let arrs = [];
              Object.values(this.globalModel.formModel).map((value) => {
                if (Array.isArray(value)) {
                  const obj = value[0];
                  if (obj) {
                    const key = Object.keys(obj)[0] || "";
                    if (key.includes(next.tableName + "_")) {
                      arrs.push(value);
                    }
                  }
                }
              });
              arrs = cloneDeep(arrs);
              this.unprefix(arrs);
              console.log(arrs);
              const result = arrs.reduce((prev, arr) => {
                return (
                  prev +
                  arr.reduce((prev, obj) => {
                    let val;
                    try {
                      val = Number(obj[next.key]);
                    } catch (error) {
                      console.error(error);
                    }
                    return prev + val;
                  }, 0)
                );
              }, 0);
              return prev + this.disposeValue(result, rule[index - 1].value);
            }
          }
        }
        return prev + next.value;
      }, "");
      console.log("dynamicCalc", resultString);
      // console.log(new Function(`return ${resultString}`)());、
      try {
        return new Function(`return ${resultString}`)();
      } catch (e) {
        console.error(e);
        return "";
      }
    },
    unprefix(param) {
      if (Array.isArray(param)) {
        param.map((arr) => {
          arr.map((obj) => {
            Object.keys(obj).map((key) => {
              const originKey = key.split("-")[1];
              obj[originKey] = obj[key];
            });
          });
        });
      } else if (Object.prototype.toString.call(param) === "[object Object]") {
        Object.keys(param).map((key) => {
          const originKey = key.split("-")[1];
          param[originKey] = param[key];
        });
      }
    },
    disposeValue(value, operator) {
      console.log("disposeValue", value, ":", operator);
      try {
        value = Number(value);
      } catch (error) {
        console.error(error);
      }
      switch (operator) {
        case "+":
        case "-":
        case "*":
          return value || 0;
        case "/":
          return value || 1;
        default:
          return value || 0;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.field {
  border: 1px solid #dcdfe6;
  height: 36px;
  line-height: 36px;
  padding: 0 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
}
.designStyle {
  height: 40px;
  line-height: 40px;
}
.ChineseUppercase {
  // position: absolute;
  top: 0;
}
.fieldContent {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // padding: 0 10px;
  div {
    flex: 1;
  }
}
</style>
